import { useEffect, useState } from "react";
import { publicApi } from "@/lib/api";

const cache = {};

export function usePublicGet(path) {
  const [state, setState] = useState(() => ({ data: cache[path], error: null, loading: !cache[path] }));
  useEffect(() => {
    let alive = true;
    setState({ data: cache[path], error: null, loading: !cache[path] });
    publicApi.get(path)
      .then((r) => { cache[path] = r.data; if (alive) setState({ data: r.data, error: null, loading: false }); })
      .catch((e) => { if (alive) setState({ data: null, error: e, loading: false }); });
    return () => { alive = false; };
  }, [path]);
  return state;
}

export const readMin = (post) => post.read_min || Math.max(3, Math.round((post.content || "").split(/\s+/).length / 220));
export const fdateLong = (d) => (d ? new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "");
export const ZONES = ["France", "Gironde", "Nouvelle-Aquitaine"];
